interface ErrorPanelProps {
  error: string;
}

function ErrorPanel({ error }: Readonly<ErrorPanelProps>) {
  return <div role="alert">{error}</div>;
}

export default ErrorPanel;
